import { Component, OnInit } from '@angular/core';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'convfact-concepttabs',
    templateUrl: './concept-tabs.component.html',
    styleUrls: ['./concept-tabs.component.scss'],
    standalone: false
})
export class ConceptTabsComponent implements OnInit {
  routes: object[];

  isSelected = false;
  isResponsive: boolean;

  constructor(
    private headerTabService: HeaderTabService
  ) {
    this.routes = [
      { label: 'Conceptos', link: '/concept/edit', enable: true },
      { label: 'Familias', link: '/concept/conceptfamily', enable: true },
      { label: 'Pedidos', link: '/concept/orders', enable: true },
      // { label: 'Stock', link: '/concept/controlstock', enable: false },
      { label: 'Estadísticas', link: '/concept/statistics', enable: true },
      { label: 'Informe ventas', link: '/concept/salesreport', enable: true },
      {label:'Descuentos', link:'/concept/vouchers', enable:true}
    ];
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });

  }

  onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }

}
